import { Routes, Route } from "react-router-dom";
import DiseaseAreasList from "./DiseaseAreasList";
import DiseaseAreaForm from "./DiseaseAreaForm";

export default function DiseaseAreasRoutes() {
  return (
    <Routes>
      <Route index element={<DiseaseAreasList />} />
      <Route path="new" element={<DiseaseAreaForm />} />
      <Route path=":id/edit" element={<DiseaseAreaForm />} />
    </Routes>
  );
}
